<iframe 
  [src]="mapsURL | safe: 'resourceUrl' " 
  width="100%" height="{{height}}" 
  frameborder="0" 
  allowfullscreen webkitallowfullscreen mozallowfullscreen>
</iframe>


